import * as React from "react";
import styled from "styled-components";
import { useSelect } from "@hubper/theme";
import { useSpring, animated } from "react-spring";

// @ts-ignore
// tslint:disable-next-line:no-empty
function nope() {}

/**
 * RadioButton
 */

const OUTER_SIZE = 16;
const INNER_SIZE = 6;

const RadioButtonBase = styled(animated.div)`
  width: ${OUTER_SIZE}px;
  height: ${OUTER_SIZE}px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-width: 1px;
  border-style: solid;
`;

const Circle = styled(animated.div)`
  width: ${INNER_SIZE}px;
  height: ${INNER_SIZE}px;
  border-radius: 50%;
`;

type Props = {
  value?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
  over?: boolean;
};

function RadioButton(
  { value, onClick, style, className, over }: Props,
  ref: any
) {
  const { color } = useSelect();

  const [isOver, setOver] = React.useState(false);

  const outerProps = useSpring({
    background: `radial-gradient(ellipse at center, ${
      value ? color(["primary", 5]) : "white"
    } 0%, ${value ? color(["primary", 4]) : "white"} 100%)`,
    borderColor: value ? "rgba(255,255,255, 0)" : color(["grey", 1]),
    config: {
      tension: 400,
      mass: 1,
      friction: 30
    }
  });

  const innerProps = useSpring({
    background:
      (isOver || over) && !value
        ? `radial-gradient(ellipse at center, ${color([
            "primary",
            1
          ])} 0%, ${color(["primary", 2])} 100%)`
        : `radial-gradient(ellipse at center, white 0%, ${
            value ? color(["grey", 1]) : "white"
          } 100%)`,
    transform: `scale(${value || ((isOver || over) && !value) ? 1 : 0})`,
    boxShadow: `0 1px 3px rgba(0,0,0,${value ? 0.2 : 0})`,
    config: {
      tension: 400,
      mass: 1,
      friction: 20
    }
  });

  return (
    <RadioButtonBase
      ref={ref}
      className={className}
      style={{
        ...outerProps,
        cursor: value ? "default" : "pointer",
        ...(style || {})
      }}
      onMouseEnter={() => setOver(true)}
      onMouseLeave={() => setOver(false)}
      onClick={(!value && onClick) || nope}
    >
      <Circle style={innerProps} />
    </RadioButtonBase>
  );
}

export default React.forwardRef(RadioButton);
